import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { BlockKeyboardDirective } from './directives/block-keyboard/block-keyboard.directive';
import { BoldMarkedTextPipe } from './pipes/bold-marked-text.pipe/bold-marked-text.pipe';
import { ContentWithImageComponent } from './components/content-with-image/content-with-image.component';
import { FormComponent } from './components/form/form.component';
// import { FormOldComponent } from './components/old/form/form.component';
import { ModalComponent } from './components/modal/modal.component';
// import { ModalOldComponent } from './components/old/modal/modal.component';
import { NumericalInputComponent } from './components/numerical-input/numerical-input.component';
import { CustomOptionComponent } from './components/form-components/form-autocomplete/custom-option/custom-option.component';

@NgModule({
  declarations: [
    BlockKeyboardDirective,
    BoldMarkedTextPipe,
    ContentWithImageComponent,
    FormComponent,
    // FormOldComponent,
    ModalComponent,
    // ModalOldComponent,
    NumericalInputComponent,
    CustomOptionComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule,
    MatButtonModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatDividerModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    BlockKeyboardDirective,
    BoldMarkedTextPipe,
    ContentWithImageComponent,
    FormComponent,
    // FormOldComponent,
    MatAutocompleteModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    ModalComponent,
    // ModalOldComponent,
    NumericalInputComponent,
    CustomOptionComponent,
  ],
})
export class SharedModule {}
